import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { TOOL_TEMPLATE } from "../constant/common";
import {
  useCompanySettings,
  useInstrumentsSetting,
  usePeersSetting,
  useTemplateSetting,
} from "../hooks/useCompanySettings";
import useInstruments from "../hooks/useInstruments";
import { loadedInstrumentSelector } from "../store/slice/trade";
import { classNames } from "../utils";
import MultipleTickerRadio from "./MultipleTickerRadio";
import MultipleTickerSlider from "./MultipleTickerSlider";
import SingleTicker from "./SingleTicker";

export default function MultipleTicker() {
  const template = useTemplateSetting();
  const [{ instruments }, { getInstruments }] = useInstruments();
  const instrumentsSetting = useInstrumentsSetting();
  const peersSetting = usePeersSetting();
  const { tickerRefreshTime, peerEnabled } = useCompanySettings();

  useEffect(() => {
    const ids = peerEnabled
      ? instrumentsSetting.map(i => i.id).concat(peersSetting.map(i => i.id))
      : instrumentsSetting.map(i => i.id);

    if (instrumentsSetting.length) {
      getInstruments(ids);
    }
    const interval = setInterval(() => {
      if (instrumentsSetting.length) {
        getInstruments(ids);
      }
    }, tickerRefreshTime * 1000);
    return () => {
      clearInterval(interval);
    };
  }, [getInstruments, instrumentsSetting, tickerRefreshTime, peersSetting]);

  const loadedInstruments = useSelector(loadedInstrumentSelector);

  if (!loadedInstruments) return null;
  return (
    <div
      className={classNames("MultipleTicker", {
        single: instruments?.length === 1,
      })}
    >
      {template === TOOL_TEMPLATE.quadrata && (
        <>
          {instruments?.length === 1 ? (
            <SingleTicker data={instruments?.[0] || {}} />
          ) : (
            <MultipleTickerRadio />
          )}
        </>
      )}
      {template === TOOL_TEMPLATE.victor && (
        <>
          {instruments?.length === 1 ? (
            <SingleTicker data={instruments?.[0] || {}} />
          ) : (
            <>
              <MultipleTickerSlider />
              <div className="MultipleTicker__bar"></div>
            </>
          )}
        </>
      )}
    </div>
  );
}
